'use client';
import { useGlobalErrorHandler } from '@mf/common/components/Logs/GlobalErrorHandler.hooks';

export function GlobalErrorHandler() {
  useGlobalErrorHandler();
  return null;
}
